<script setup>
// ContactDetailActivity.vue — placeholder pra tab "Atividade".
//
// MVP: nao temos timeline de eventos do contato no backend hoje. Quando
// houver, listar aqui (criacao, atualizacoes, bloqueio, merge, etc).
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<template>
  <div class="flex flex-col items-center justify-center h-full px-6 py-16">
    <div
      class="flex items-center justify-center size-12 rounded-lg bg-n-alpha-2 text-n-slate-11 mb-4"
    >
      <span class="i-lucide-history size-6" />
    </div>
    <h3 class="text-base font-medium text-n-slate-12 mb-1">
      {{ t('CONTACT_VIEW.ACTIVITY.EMPTY_TITLE') }}
    </h3>
    <p class="text-sm text-n-slate-11 text-center max-w-sm">
      {{ t('CONTACT_VIEW.ACTIVITY.EMPTY_DESCRIPTION') }}
    </p>
  </div>
</template>
